import type { IModalActionForm, IModalActionResolver } from "@complex/Actions/Modal/logics/types";
import { Typography } from "@mui/material";
import { FormControlLabel, Switch } from "@mui/material";
import { Stack } from "@mui/material";
import { type Control, Controller } from "react-hook-form";
import { NextActionDate } from "./date";

interface INextActionProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const NextAction = ({ control }: INextActionProps) => {
  return (
    <Stack
      sx={{
        gap: 1,
      }}
    >
      <Controller
        name="nextAction"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
            control={
              <Switch
                sx={{ marginRight: -1 }}
                onChange={(_, checked) => field.onChange(checked)}
                checked={field.value}
                color="primary"
              />
            }
            label={<Typography>Prévoir une prochaine action identique </Typography>}
            labelPlacement="start"
          />
        )}
      />
      <NextActionDate control={control} />
    </Stack>
  );
};
